import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MoneyService {

  constructor() { }

  convertIntoDollars(sum: number): number {
    return sum / 100;
  }

  convertIntoCents(sum: number): number {
    return Math.round(sum * 100);
  }
}
